module.exports = __webpack_public_path__ + "img/EditorialLebenInDerGegenwartThumbnail.f6017207.jpg";